import { logger } from './logger';
/**
 * Build information utility
 * Provides version and deployment date information
 */

// Get version from package.json (this will be replaced during build)
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0';

// Get build timestamp (this will be injected during deployment)
// Format: ISO string or timestamp
export const BUILD_TIMESTAMP = process.env.REACT_APP_BUILD_TIMESTAMP || null;

/**
 * Get formatted deployment date/time in PST timezone
 */
export const getDeploymentDateTime = (): string | null => {
  if (!BUILD_TIMESTAMP) return null;

  try {
    // Parse the timestamp (should be ISO string from deployment script)
    let timestamp: number;
    if (typeof BUILD_TIMESTAMP === 'string') {
      timestamp = Date.parse(BUILD_TIMESTAMP);
    } else {
      timestamp = Number(BUILD_TIMESTAMP);
    }

    if (isNaN(timestamp)) {
      logger.warn('Invalid BUILD_TIMESTAMP:', BUILD_TIMESTAMP);
      return null;
    }

    // Convert to PST (UTC-8) or PDT (UTC-7) depending on daylight saving
    const date = new Date(timestamp);
    
    // Format in PST/PDT timezone
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    });

    return formatter.format(date);
  } catch (error) {
    logger.error('Error formatting deployment date:', error);
    return null;
  }
};

/**
 * Get build info object
 */
export const getBuildInfo = () => {
  return {
    version: APP_VERSION,
    deploymentDate: getDeploymentDateTime(),
    buildTimestamp: BUILD_TIMESTAMP
  };
};

